import  {  useEffect } from "react";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
import asavault_logo from "../../assets/Images/asavaultlogo.png";
import { useNavigate, useLocation } from "react-router-dom";

import "../../assets/css/style.css";
import {useAsaSession,useIsLoading,useAsaSessionPagesMutation} from '../../services/AsaSessionServices'
const AuthenticationScreen = () => {

  const location = useLocation();
  const passedData = location.state;
  const navigate = useNavigate();

  const [isLoading, ] = useIsLoading();
  const {data:session}=useAsaSession()

  useEffect(() => {
    AnalyticsService.track("CRB Authentication Viewed", AnalyticsAction.View, AnalyticsFeature.CRB);
    if (!!!session) {
      console.log("Session data NOT available");
      navigate("/error", { state: passedData });
      // Session data not available, handle accordingly (e.g., navigate back to landing screen)
    } else {

        setTimeout(() => {
        
          navigate("/home", { state: passedData });
        }, 3000); // 3000 milliseconds = 3 seconds

    }
  }, [session]);


  return (
    <div className="flex bg-theme asavault_logo  flex-col items-center justify-center h-screen">
      <img src={asavault_logo} alt="ASA Vault Logo" className="h-16 mb-4" />
      <p className="text-base text-white poppins-medium mb-2">
        Authenticating...
      </p>
      {isLoading && (
        <div className="animate-spin h-8 w-8 border-t-2 border-b-2 border-white-900 rounded-full"></div>
      )}
    </div>
  );
};

export default AuthenticationScreen;
